import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/mockData';
import { Button } from './ui/button';

const PaymentCancel = () => {
  const { language } = useLanguage();
  const t = translations[language].paymentCancel;
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#141619] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        {/* Cancel Icon */}
        <div className="w-24 h-24 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-8">
          <XCircle className="w-14 h-14 text-red-500" />
        </div>

        {/* Title */}
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-4" data-testid="payment-cancel-title">
          {t.title}
        </h1>

        {/* Message */}
        <p className="text-[#9CA3AF] text-lg mb-8">
          {t.message}
        </p>

        {/* Action Buttons */}
        <div className="space-y-4">
          <Button
            onClick={() => navigate('/checkout')}
            className="w-full bg-[#D4AF37] hover:bg-[#c9a432] text-[#141619] px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105"
            data-testid="try-again-btn"
          >
            {t.tryAgain}
          </Button>
          
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="w-full border-[#2a2d32] text-white hover:bg-[#1a1d21] px-8 py-4 rounded-full font-medium transition-all duration-300"
            data-testid="back-home-btn"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            {t.backHome}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
